//用于定义存储的变量
function loadLocal() {
    return localStorage.getItem("testItem", 'true and false')
  }
  const state = {
    //获取用户信息
    userId:'',
    token:'',
    productId:'',
    videoId:'',
    channelType:'',
    channelList:'',
  }
  
  export default state
  


// WEBPACK FOOTER //
// ./src/store/state.js